import { api } from '@kolab/dms-base/api'
import type {
  ActivateDeviceRequest,
  ActivateDeviceResponse,
  DeviceLicense,
  DeviceStatus,
  PageableQuery,
  PaginatedResponse,
  ValidateLicenseRequest,
  ValidateLicenseResponse,
} from './types'

const BASE = '/v1/device-licenses'

export interface ListDeviceLicensesQuery extends PageableQuery {
  resellerLicenseId?: string
  status?: DeviceStatus | ''
}

export async function listDeviceLicenses(params?: ListDeviceLicensesQuery) {
  return api.get<PaginatedResponse<DeviceLicense>>(BASE, { params, _suppressErrorToast: true }).then((r) => r.data)
}

export async function getDeviceLicense(id: string) {
  return api.get<DeviceLicense>(`${BASE}/${id}`).then((r) => r.data)
}

export async function activateDevice(payload: ActivateDeviceRequest) {
  return api.post<ActivateDeviceResponse>(`${BASE}/activate`, payload).then((r) => r.data)
}

export async function deactivateDevice(id: string) {
  return api.post<DeviceLicense>(`${BASE}/${id}/deactivate`).then((r) => r.data)
}

export async function revokeDevice(id: string) {
  return api.post<DeviceLicense>(`${BASE}/${id}/revoke`).then((r) => r.data)
}

export async function wipeDevice(id: string) {
  return api.post<DeviceLicense>(`${BASE}/${id}/wipe`).then((r) => r.data)
}

export async function validateLicense(payload: ValidateLicenseRequest) {
  return api.post<ValidateLicenseResponse>(`${BASE}/validate`, payload).then((r) => r.data)
}
